import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from './shared.service';

@Injectable()
export class LoginService {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }

  public loginClient(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/customer/login', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('loginClient', {error: ''}))
    );
  }

  public loginFranchisor(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/franchisor/login', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('loginClient', {error: ''}))
    );
  }

  public sendResetEmail(emailAddress: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/reset/password/request', emailAddress, this.jsonOptions).pipe(
      catchError(this.handleError<any>('sendResetEmail', {error: ''}))
    );
  }

  public sendResetPasswordSMS(mobileNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/reset/password/request/otp', mobileNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any>('sendResetPasswordSMS', {error: ''}))
    );
  }

  public resetUserPassword(newPasswordData: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/submit/new/password', newPasswordData, this.jsonOptions).pipe(
      catchError(this.handleError<any>('resetUserPassword', {error: ''}))
    );
  }

  public resetInfluencerUserPassword(newPasswordData: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/submit/new/password/influencer', newPasswordData, this.jsonOptions).pipe(
      catchError(this.handleError<any>('resetUserPassword', {error: ''}))
    );
  }

  public loginManager(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/manager/login', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('loginManager', {error: ''}))
    );
  }

  public registerSalesAgent(salesAgent:any) {
   return this.http.post(this.sharedService.getFranchiseUrl()+'session/register/sales/agent',salesAgent,this.jsonOptions).pipe(
     catchError(this.handleError<any>('createSalesAgent', {})),
   );
  }

  public loginManagerForCustomer(): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/customer-reseller/login', this.jsonOptions).pipe(
      catchError(this.handleError<any>('loginManager', {error: ''}))
    );
  }

  public customerLoginForReseller(): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/reseller/login/to/customer', this.jsonOptions).pipe(
      catchError(this.handleError<any>('loginManager', {error: ''}))
    );
  }

  
  public validateToken(token:any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/validate/token',token, this.jsonOptions).pipe(
      catchError(this.handleError<any>('loginManager', {error: ''}))
    );
  }
}
